module.exports = __webpack_public_path__ + "img/icon-done.e249914e.svg";